export const GET_PROFILE_GROUPS_START = 'GET_PROFILE_GROUPS_START';
export const GET_PROFILE_GROUPS_SUCCESS =
  'GET_PROFILE_GROUPS_SUCCESS';
export const GET_PROFILE_GROUPS_ERROR = 'GET_PROFILE_GROUPS_ERROR';
